import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { createLogin } from "./api";
import { CreateUser, LoginResponse } from "./type";

export const useCreateLogin = () => {
    return useMutation<LoginResponse, AxiosError, CreateUser>({
        mutationFn: createLogin, // Fonction qui effectue le POST
        retry: 1,
    });
};